import { LOCALE_EN, LOCALE_RU } from '../constant';
import { RECIPES_URL, getFetchRequest } from '../store/requests';
import {
    buildCsv,
    downloadCsvFile,
    getLocalizedName,
} from './csvExportUtils';
import { errorCallback, makeUrl } from '../util';
import { RecipeCharacteristicCategory } from './recipeTypes';

const RECIPES_EXPORT_QUERY = '?withProducts=true';

const RECIPE_CSV_HEADERS = [
    'recipeId',
    'recipeType',
    'takeAsIs',
    'baseMin',
    'baseMax',
    'addsMin',
    'addsMax',
    'tastyMin',
    'tastyMax',
    'baseShare',
    'addsShare',
    'dateCreated',
    'nameRu',
    'nameEn',
    'tastes',
    'sources',
    'productCategories',
    'ingredientId',
    'ingredientGroup',
    'ingredientType',
    'unitWeight',
    'amountKind',
    'amountValue',
    'ingredientPartId',
    'productCode',
    'ingredientForms',
];

const formatBool = (value) => (value === true ? 'true' : value === false ? 'false' : '');

const formatCharacteristics = (characteristics, category) => (characteristics || [])
    .filter((item) => item.category === category)
    .map((item) => item.value || '')
    .filter(Boolean)
    .join(';');

const formatIngredientForms = (forms) => (forms || []).map((form) => {
    const code = form.formCode || form.productForm || '';
    const type = form.formType || '';
    const group = form.formGroup || '';
    return `${code}:${type}:${group}`;
}).join(';');

const mapRecipeBaseFields = (recipe) => ([
    recipe.id || '',
    recipe.recipeType || '',
    formatBool(recipe.takeAsIs),
    recipe.baseMin ?? '',
    recipe.baseMax ?? '',
    recipe.addsMin ?? '',
    recipe.addsMax ?? '',
    recipe.tastyMin ?? '',
    recipe.tastyMax ?? '',
    recipe.baseShare ?? '',
    recipe.addsShare ?? '',
    recipe.dateCreated || '',
    getLocalizedName(recipe.names, LOCALE_RU),
    getLocalizedName(recipe.names, LOCALE_EN),
    formatCharacteristics(recipe.characteristics, RecipeCharacteristicCategory.RECIPE_CHARACTERISTIC_TASTE),
    formatCharacteristics(recipe.characteristics, RecipeCharacteristicCategory.RECIPE_CHARACTERISTIC_SOURCE),
    formatCharacteristics(recipe.characteristics, RecipeCharacteristicCategory.RECIPE_CHARACTERISTIC_PRODUCT_CATEGORY),
]);

const mapIngredientBaseFields = (ingredient) => ([
    ingredient?.id || '',
    ingredient?.ingredientGroup || '',
    ingredient?.ingredientType || '',
    ingredient?.unitWeight ?? '',
    ingredient?.amountKind || '',
    ingredient?.amountValue ?? '',
]);

const mapIngredientPartRow = (recipe, ingredient, part) => [
    ...mapRecipeBaseFields(recipe),
    ...mapIngredientBaseFields(ingredient),
    part?.id || '',
    part?.productCode || '',
    formatIngredientForms(part?.ingredientForms),
];

export const exportRecipesToCsv = (onComplete) => {
    getFetchRequest(
        makeUrl([RECIPES_URL, RECIPES_EXPORT_QUERY]),
        (recipes) => {
            const rows = [];
            (recipes || []).forEach((recipe) => {
                const ingredients = recipe.ingredients || [];
                if (ingredients.length === 0) {
                    rows.push([
                        ...mapRecipeBaseFields(recipe),
                        '', '', '', '', '', '', '', '', '',
                    ]);
                    return;
                }
                ingredients.forEach((ingredient) => {
                    const parts = ingredient.ingredientParts || [];
                    if (parts.length === 0) {
                        rows.push(mapIngredientPartRow(recipe, ingredient, null));
                        return;
                    }
                    parts.forEach((part) => {
                        rows.push(mapIngredientPartRow(recipe, ingredient, part));
                    });
                });
            });
            const csv = buildCsv(RECIPE_CSV_HEADERS, rows);
            downloadCsvFile('recipes.csv', csv);
            onComplete?.();
        },
        (err) => {
            errorCallback(err);
            onComplete?.();
        },
    );
};
